import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text
} from '@chakra-ui/react'
import { generateVisitFields } from './utils'

import { useIntl } from 'react-intl'
import { useAccount } from '../../../../client/modules/account/AccountProvider'
import messages from './messages'
interface Props {
  isOpen: boolean
  onClose: () => void
  values: any
}

export default function VisitView({ isOpen, onClose, values }: Props) {
  const { formatMessage } = useIntl()
  const { schema } = useAccount()

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(2px) " />
      <ModalContent maxW="800px">
        <ModalHeader>
          <Text fontWeight="bold" fontSize="lg" color="gray.800">
            {values?.isFollowUp
              ? formatMessage(messages.followUp)
              : formatMessage(messages.visit)}
          </Text>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Flex flexDir="column" justifyContent="space-between" h="full" p={8}>
            <SimpleGrid columns={2} gap={4} w="full">
              {!!values &&
                schema.visit.fields.map((field) =>
                  generateVisitFields(field, values)
                )}
            </SimpleGrid>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
